<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      Chatbot
    </mat-card-title>
  </mat-card-header>
  <mat-card-content *ngIf="enableChatbot">
    <iframe src='https://webchat.botframework.com/embed/OHA-PH-SDD-SampleQnAMakerBot?s=2a-lIdazG-c.XU8lMLExocEtwI-QZQJv8m0yukFYYPdZBrME5iyU0Uc'
            style='min-width: 200px; width: 100%; min-height: 500px;'>
    </iframe>
  </mat-card-content>
</mat-card>
